<template>
  <ZoomOneEduPlanDetail v-bind="{ visible, id, currencySymbol, bizCategoryCode, largeMeetingCallback, fullListCallBack, enableDocsFeature, enableDisplayZoomTasksWithoutAccountCheck }" @closed="handleCancel">
    <p slot="footer" class="opc-zeduschp-detail-tip">
      *{{ $t('billing.zone.edu_details.tips', [20, $money(annualPriceNum * 20, { forceDiff: true })]) }}
    </p>
  </ZoomOneEduPlanDetail>
</template>

<script>
import { mapGetters } from 'vuex';

import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { getCurrency, getCurrencySymbol } from "@/utils/currency";
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';

export default {
  name: 'ZEduPlusPlanDetail',
  mixins: [ConfirmComponent],
  props: {
    bizCategoryCode: String,
    fullListCb: Function,
    largeMeetingCb: Function,
  },
  data() {
    return {
      visible: false,
      id: 'schoolPlus',
      currencySymbol: getCurrencySymbol(getCurrency()),
      enableDocsFeature: window.newBillingConfig.enableDocsFeature,
      enableDisplayZoomTasksWithoutAccountCheck: window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck
    }
  },
  computed: {
    ...mapGetters(['planMapFlat']),
    annualPriceNum() {
      const zoneBundlePlans = plansof(this.planMapFlat).type(planTypes.ZONE_EDU_PLUS).annual();
      const category0 = zoneBundlePlans.clone().get(0)?.category;
      return zoneBundlePlans.category(category0).sum('price');
    },
    largeMeetingCallback() {
      if (typeof this.largeMeetingCb == 'function') {
        return () => {
          this.largeMeetingCb()
          this.handleCancel()
        }
      }
      return null
    }
  },
  methods: {
    fullListCallBack() {
      typeof this.fullListCb == 'function' && this.fullListCb()
      this.handleCancel()
    }
  }
}
</script>
